var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-6"},[_c('div',{staticClass:"text-sm font-semibold text-white"},[_vm._v("\n    Categories\n  ")]),_vm._v(" "),_c('nav',{staticClass:"mt-8"},[_c('ul',{staticClass:"space-y-3"},[_c('LinkGroup',{attrs:{"parent":{
          text: 'Adobe After Effects',
          link: ''
        },"children":[
          {
            text: 'Adobe After Effects Templates',
            link: '/browse/after-effects-templates/'
          },
          {
            text: 'Adobe After Effects Presets',
            link: '/browse/after-effects-presets/'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Adobe Premiere Pro',
          link: ''
        },"children":[
          {
            text: 'Adobe Premiere Pro Templates',
            link: '/browse/premiere-pro-templates/'
          },
          {
            text: 'Adobe Premiere Pro Presets',
            link: '/browse/premiere-pro-presets/'
          },
          {
            text: 'MOGRTs',
            link: '/browse/motion-graphics-templates/'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Adobe Premiere Rush',
          link: ''
        },"children":[
          {
            text: 'Adobe Premiere Rush Templates',
            link: '/browse/premiere-rush-templates/'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'DaVinci Resolve',
          link: ''
        },"children":[
          {
            text: 'DaVinci Resolve Templates',
            link: '/browse/davinci-resolve-templates/'
          },
          {
            text: 'DaVinci Resolve Macros',
            link: '/browse/davinci-resolve-macros/'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Final Cut Pro',
          link: ''
        },"children":[
          {
            text: 'Final Cut Pro Templates',
            link: '/browse/final-cut-pro-templates/'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Images',
          link: ''
        },"children":[
          {
            text: 'Stock Photos',
            link: '/browse/stock-photos/'
          },
          {
            text: 'Graphics',
            link: '/browse/graphics/'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Stock Audio',
          link: ''
        },"children":[
          {
            text: 'Royalty Free Music',
            link: '/browse/royalty-free-music/'
          },
          {
            text: 'Sound Effects',
            link: '/browse/sound-effects/'
          } ]}}),_vm._v(" "),_c('LinkGroup',{attrs:{"parent":{
          text: 'Stock Video',
          link: ''
        },"children":[
          {
            text: 'Stock Video Footage',
            link: '/browse/stock-video/'
          },
          {
            text: 'Motion Graphics',
            link: '/browse/stock-motion-graphics/'
          } ]}}),_vm._v(" "),_vm._m(0)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"footer-link",attrs:{"href":"/browse/voice-over/"}},[_vm._v("Voiceover")])])}]

export { render, staticRenderFns }